'use client';

import { useCheckoutContext } from '@instamenu/context-checkout';
import { Box, Text } from '@instamenu/ui-system-next';
import { itemCount } from './item-count.css';
import { observer } from 'mobx-react-lite';

export type ItemCountProps = {
  id: string;
};

export const ItemCount = observer(({ id }: ItemCountProps) => {
  const checkout = useCheckoutContext();
  const num = checkout?.numInCart(id);
  if (num)
    return (
      <Box className={itemCount}>
        <Text variant="caption1">{num}</Text>
      </Box>
    );
});
